import * as tslib_1 from "tslib";
import styled, { withProps } from '../styles';
var Divider = withProps()(styled.hr)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", "px;\n  border: none;\n  margin: 0;\n  padding: 0;\n  background-color: ", ";\n  width: ", ";\n  margin-left: ", "px;\n"], ["\n  height: ", "px;\n  border: none;\n  margin: 0;\n  padding: 0;\n  background-color: ", ";\n  width: ",
    ";\n  margin-left: ", "px;\n"])), function (props) { return (props.height ? props.height : 1); }, function (props) { return props.theme.palette.text.divider; }, function (props) {
    return typeof props.width === 'number'
        ? props.width + "px"
        : props.width || 'auto';
}, function (props) { return (props.inset ? 72 : 0); });
export default Divider;
var templateObject_1;
//# sourceMappingURL=Divider.js.map